module.exports = "<div *ngIf=\"messageService.messages.length\">\n\n  <h2>Messages</h2>\n  <button class=\"btn btn-info\"\n          (click)=\"messageService.clear()\">clear\n  </button>\n  <div class=\"alert alert-danger\" role=\"alert\"\n       *ngFor='let message of messageService.messages'>\n    {{message}}\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/message/message.component.html
// module id = ../../../../../src/app/message/message.component.html
// module chunks = main